import React from "react";
import { Link } from "react-router-dom";
import { Compass, CloudSun, Anchor, ShieldCheck, Map } from "lucide-react";
import { getWireCopy } from "@/i18n";
import WireLongformGuide from "@/components/public/WireLongformGuide";

const topicIcons = [CloudSun, Anchor, Map, ShieldCheck];
const resourceHrefs = ["/weather", "/learning-center", "/sailing-calculators", "/marinas-near-me"];

export default function WireSeoSections({ lang = "en" }) {
  const copy = getWireCopy(lang);

  return (
    <>
      <section className="mt-10 grid gap-4 md:grid-cols-2 lg:grid-cols-4">
        {copy.topics.map(({ title, text }, index) => {
          const Icon = topicIcons[index];
          return (
            <article key={title} className="rounded-3xl border border-border bg-card p-5 shadow-sm">
              <Icon className="h-5 w-5 text-primary" />
              <h2 className="mt-4 text-lg font-black text-foreground">{title}</h2>
              <p className="mt-2 text-sm leading-6 text-muted-foreground">{text}</p>
            </article>
          );
        })}
      </section>

      <section className="mt-10 rounded-[2rem] border border-border bg-card p-6 shadow-xl md:p-8">
        <div className="grid gap-8 lg:grid-cols-[0.9fr_1.1fr] lg:items-center">
          <div>
            <p className="text-sm font-black uppercase tracking-[0.22em] text-primary">{copy.intelligenceEyebrow}</p>
            <h2 className="mt-3 font-heading text-3xl font-black leading-tight md:text-5xl">{copy.intelligenceTitle}</h2>
            <p className="mt-4 leading-7 text-muted-foreground">{copy.intelligenceText}</p>
          </div>
          <div className="grid gap-3 sm:grid-cols-2">
            {copy.resources.map((label, index) => (
              <Link key={resourceHrefs[index]} to={`/${lang}${resourceHrefs[index]}`} className="flex items-center justify-between rounded-2xl border border-border bg-background/70 p-4 font-black text-foreground transition hover:border-primary/50 hover:text-primary">
                {label}
                <Compass className="h-4 w-4" />
              </Link>
            ))}
          </div>
        </div>
      </section>

      <WireLongformGuide copy={copy} />
    </>
  );
}